<template>

  <div class="bg-white overflow-hidden shadow-sm p-3 sm:rounded-xs border my-3">

    <!-- devex progress bar test start -->
    <div class="flex justify-between">
     <div>
      <h6>Leave Used</h6>
      <p class="text-xs">42%</p>
     </div>

    <div class="">
      <div class="max-w-xs mx-auto">
         
          <div class="relative">
            <button class="px-4 py-2 border border-blue-500 text-gray-500 font-semibold rounded hover:bg-blue-500 hover:text-white transition-colors duration-200">
               Details
            </button>
          </div>
      </div>
    </div>

     </div>
     

    <DxChart id="chart" :data-source="filteredDataSource" 
    :rotated="true" :size="{ height: 120 }">
      <DxArgumentAxis 
      :label="{ visible: false }"
      :visible="false"
      :tick="{ visible: false }"
      :grid="{ visible: false }">
      </DxArgumentAxis>

      <DxValueAxis 
      :label="{ visible: false }"
      :visible="false"
      :tick="{ visible: false }"
      :grid="{ visible: false }"> 
      </DxValueAxis>

      <DxCommonSeriesSettings argument-field="type" type="fullstackedbar" :bar-padding="0.7"/>
    
    <DxSeries v-for="(series, index) in seriesData" :key="index" :value-field="series.valueField" :name="series.name" :color="series.color" />
    
    
    <DxLegend vertical-alignment="bottom" horizontal-alignment="center" item-text-position="right" />
    
    <DxTooltip :enabled="true" :customize-tooltip="customizeTooltip" />
     
    </DxChart>
    <!-- devex progress bar test end -->
     <hr>

     <!-- Leave type, total, credit and balance start from here -->
     

<div class="relative overflow-x-auto">
    <table class="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
        <thead class="text-xs text-gray-700 uppercase bg-gray-100 dark:bg-gray-700 dark:text-gray-400">
            <tr>
                <th scope="col" class="px-6 py-2 rounded-s-lg">
                    Leave Types
                </th>
                <th scope="col" class="px-6 py-2">
                   Credited/ Total
                </th>
                <th scope="col" class="px-6 py-2 rounded-e-lg">
                    Balance
                </th>
            </tr>
        </thead>
        <tbody>
            <tr class="bg-white dark:bg-gray-800">
                <th scope="row" class="px-6 py-3 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                    Earned Leave
                </th>
                <td class="px-6 py-3">
                    18/18
                </td>
                <td class="px-6 py-3">
                    4
                </td>
            </tr>
            <tr class="bg-white dark:bg-gray-800">
                <th scope="row" class="px-6 py-3 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                   Casual Leave
                </th>
                <td class="px-6 py-3">
                    3/12
                </td>
                <td class="px-6 py-3">
                    1
                </td>
            </tr>
            <tr class="bg-white dark:bg-gray-800">
                <th scope="row" class="px-6 py-3 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                    Sick Leave
                </th>
                <td class="px-6 py-3">
                  3/12
                </td>
                <td class="px-6 py-3">
                    1
                </td>
            </tr>
        </tbody>
        <tfoot>
            <tr class="font-semibold text-gray-900 dark:text-white">
                <th scope="row" class="px-6 py-3 text-base">Total</th>
                <td class="px-6 py-3">24/42</td>
                <td class="px-6 py-3">6</td>
            </tr>
        </tfoot>
    </table>
</div>

     <!-- Leave type, total, credit and balance end -->
  </div>

</template>

<script>
import JetButton from '@/Jetstream/Button.vue'
import {
  DxArgumentAxis,
  DxLabel,
  DxGrid,
  DxTick,
  DxValueAxis,
  DxChart,
  DxSeries,
  DxCommonSeriesSettings,
  DxTitle,
  DxLegend,
  DxTooltip,
  DxAnnotations,
  DxAnnotation
} from 'devextreme-vue/chart';

export default {
  components: {
    JetButton,
    DxArgumentAxis,
    DxLabel,
    DxGrid,
    DxTick,
    DxValueAxis,
    DxChart,
    DxSeries,
    DxCommonSeriesSettings,
    DxTitle,
    DxLegend,
    DxAnnotations,
    DxAnnotation,
    DxTooltip,
  },

  data() {

    return {
      filteredDataSource: [
        { type: 'Leave', 
        value: 15 },
       
      ],
      seriesData: [
        { valueField: 'value', name: 'Earned Leave', color: '#ff5733' },
        { valueField: 'value', name: 'Casual Leave', color: '#33c4ff' },
        { valueField: 'value', name: 'Sick Leave', color: '#33ff57' },
      ],
      totalDays: 42,
  
    };
  },

  methods: {
    customizeTooltip(arg) {
      return {
        text: `${arg.seriesName}: ${arg.valueText} days`,
      };
    },
   
   
  },

  computed: {
  
  }
}

</script>

<style>
p {
  margin-top: 0;
  margin-bottom: 0.1rem;
}

h2, h6 {
  margin-bottom: 0.1rem;
}

.dxc-title{
  text-align: left !important;
}

/* #chart {
  height: 118px !important;
} */

</style>